import Vue from 'vue';
import Player from 'xgplayer';

Vue.prototype.$xgplayer = Player;
